import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { ShowMoreBtn } from "../../atoms/show-more-btn";
import StarShowHide from "../../atoms/star-show-hide";
import TimeStamp from "../../atoms/time-stamp";

import "./editorial-category.m.css";

const EditorialCategory = () => {
  const [loadMore, setLoadMore] = useState(5);
  const [editorialCategory, setEditorialCategory] = useState([]);
  var [showBtn, setShowBtn] = useState(true);

  useEffect(() => {
    async function fetchAPI() {
      await fetch("/api/v1/collections/paakirjoitus-jurvansanomat")
        .then((res) => res.json())
        .then((json) => setEditorialCategory(json.items))
    }
    fetchAPI();

  }, [])

  const editorialTopics = [...editorialCategory || []];

  const handleLoadMore = () => {
    setLoadMore(loadMore + 5);
    if (editorialTopics.length <= loadMore + 5) {
      setShowBtn(false)
    }
  }

  if (editorialTopics.length < 1) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="sidebar-global" styleName="sidebar-global">
        <h2 className="top-headline" styleName="top-headline">PÄÄKIRJOITUKSET</h2>
        <div>
          {editorialTopics
            .slice(0, loadMore)
            .map((item, index) => {
              const accessType = item.story.access;
              const paaaihe = item.story.metadata["pääaihe"];
              return (
                <React.Fragment key={index}>
                  <Link href={`/${item.story.slug}`} styleName="wrapper" className="wrapper-newest-category" key={index}>
                    {/*<HeroImage story={item.story} />*/}
                    <h2 styleName="headline" className="main-headline" >
                      <span styleName="span-newest">{paaaihe && `${paaaihe} | `}</span>
                      {item.story.headline}
                      {/*<Link className="main-headline" href={`/${item.story.slug}`}>{item.story.headline}</Link>*/}
                    </h2>
                    <div styleName="section-time-wrapper" className="section-time-wrapper">
                      {/*<div>
                        <SectionTag story={item.story} />
                      </div>*/}
                      <div>
                        <TimeStamp timeStamp={item.story["published-at"]} />
                      </div>
                      <StarShowHide accessType={accessType} />
                    </div>
                  </Link>
                </React.Fragment>
              );
            })}
          {(showBtn === true && editorialCategory.length > 5) &&
            <ShowMoreBtn loadMore={handleLoadMore} btnName="NÄYTÄ LISÄÄ" />
          }
        </div>
      </div>
    </React.Fragment>
  );
};

export default EditorialCategory;
